import { Component } from '@angular/core'

@Component({
  selector: 'basin-navmenu-stantec-icon',
  template: `
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.87 29.87"
    >
      <defs>
        <style>
          .cls-1 {
            fill: #fff;
          }
        </style>
      </defs>
      <g id="Group_29" data-name="Group 29">
        <g id="Group_8" data-name="Group 8">
          <g id="Group_1" data-name="Group 1">
            <path
              id="SVGID"
              class="cls-1"
              d="M11.62,27.53a9.36,9.36,0,0,0,7.92-8.12,6.29,6.29,0,0,1,.59,2.66c0,3.45-2.8,5.72-6.24,5.72a10.27,10.27,0,0,1-2.27-.26M22,9.35c-.26-.2-1-.71-1.62-1.1C18.24,6.82,16.62,6,16.62,4.41a1.71,1.71,0,0,1,1.73-1.69h.09c1.88,0,4.09,1.68,4.09,1.68a13.09,13.09,0,0,1,5.39,10.52,11.7,11.7,0,0,1-.46,3.44,11.62,11.62,0,0,0-5.45-9M4.35,22.53A13.33,13.33,0,0,1,2,14.93,13,13,0,0,1,13.44,2a3.86,3.86,0,0,0-1.63,3.38c0,2.14,1.5,4,2.73,5.78.32.45.58.91,1,1.43a10.61,10.61,0,0,1,2.15,5.71,7.27,7.27,0,0,1-7.25,7.27h0a6.84,6.84,0,0,1-6-3M0,14.93A14.94,14.94,0,1,0,14.93,0,14.94,14.94,0,0,0,0,14.93"
            />
          </g>
        </g>
      </g>
    </svg>
  `,
})
export class NavmenuStantecIconComponent {}
